export function isDirectHttpsAssetUrl(url: string | null | undefined): boolean {
  const raw = String(url || '').trim();
  return raw.startsWith('https://');
}

/** URLs that can be assigned directly to HTMLMediaElement.src without API fetch. */
export function isDirectPlaybackMediaUrl(url: string | null | undefined): boolean {
  const raw = String(url || '').trim();
  return isDirectHttpsAssetUrl(raw) || raw.startsWith('blob:');
}
